import {
  type FC,
  type Dispatch,
  type SetStateAction,
  type ReactNode,
  type ComponentType
} from 'react';
import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogTitle
} from '@/components/ui/dialog';
import { cn } from '@/lib/utils';
import { DialogTriggerProps } from '@radix-ui/react-dialog';

interface BaseModalProps {
  open: boolean;
  buttonProps?: Partial<DialogTriggerProps>;
  setOpen: Dispatch<SetStateAction<boolean>>;
  title?: string;
  dialogTitle?: string;
  children?: ReactNode;
  buttonClass?: string;
  modalClass?: string;
  ButtonLogo?: ComponentType<object>;
}

const BaseModal: FC<BaseModalProps> = ({
  open,
  title,
  ButtonLogo,
  dialogTitle,
  buttonProps,
  buttonClass,
  modalClass,
  children,
  setOpen
}) => {
  return (
    <Dialog
      open={open}
      onOpenChange={setOpen}>
      <DialogTrigger
        {...buttonProps}
        className={cn(
          'text-xs lg:text-base h-[38px] text-ellipsis overflow-hidden p-1 py-0 px-3 rounded-md select-none',
          buttonClass
        )}>
        {title && title}
        {ButtonLogo && <ButtonLogo />}
      </DialogTrigger>
      <DialogContent className={cn('min-w-[40vw]', modalClass)}>
        {dialogTitle && (
          <DialogHeader>
            <DialogTitle className="text-start text-[#0A3690] text-base font-semibold mb-3 border-b border-gray-300 pb-3">
              {dialogTitle}
            </DialogTitle>
          </DialogHeader>
        )}
        {children && children}
      </DialogContent>
    </Dialog>
  );
};

export default BaseModal;
